import i18n from '@opsbase/lib-i18n';
import Palette from '@opsbase/lib-palette';
import Horizontal from '@opsbase/web-layout/Horizontal';
import Vertical from '@opsbase/web-layout/Vertical';
import Spinner from '@opsbase/web-ui/Spinner';
import Text from '@opsbase/web-ui/Text';
import * as React from 'react';
import PageRouter from '../../../../shared/UX/PageRouter';
import OpViewAnswers from '../../../dialogs/op/OpViewAnswers';
import OpViewIssues from '../../../dialogs/op/OpViewIssues';
import OpViewOverview from '../../../dialogs/op/OpViewOverview';
const styles = {
    opcontainer: {
        backgroundColor: Palette.White.main,
        border: `1px solid ${Palette.InputBorderGrey.main}`,
    },
};
export function OnboardingOpHistory(props) {
    const { loading, op } = props;
    return (React.createElement(Spinner, { busy: loading || !op }, () => (React.createElement(Vertical, { gutter: true, paddingX: true },
        React.createElement(Text, { variant: 'h1' }, i18n.t('individual-op-report')),
        React.createElement(Text, null, i18n.t('op-report-line1')),
        React.createElement(Text, null, i18n.t('op-report-line2')),
        React.createElement("div", { style: styles.opcontainer },
            React.createElement(Horizontal, { stretch: true },
                React.createElement(OpViewOverview, { op: op }),
                React.createElement(Vertical, { style: { overflow: 'hidden' } }, (op === null || op === void 0 ? void 0 : op.issues.length) ? (React.createElement(PageRouter, { defaultPageRoute: "answers", noHistory: true, scroll: true, pageRoutes: [
                        {
                            label: i18n.t('answers'),
                            route: 'answers',
                            component: () => React.createElement(OpViewAnswers, { op: op }),
                        },
                        {
                            label: i18n.t('issues'),
                            route: 'issues',
                            component: () => React.createElement(OpViewIssues, { op: op }),
                        },
                    ] })) : (React.createElement(OpViewAnswers, { op: op })))))))));
}
export default OnboardingOpHistory;
